import React from "react";
import * as Styled from "./styles";

const Spinner = () => <Styled.Spinner />;

export default Spinner;
